const suggestionTypes = {
  filter: "filter",
  keyword: "keyword",
  jump: "jump_to",
  default: "default",
  recent: "recent",
};

export default suggestionTypes;
